import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import DelaiPaiementComponent from '../../../components/Mouvement/Panel/DelaiPaiementComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import MouvementPanel from './MouvementPanel';

class DelaiPaiementPanel extends MouvementPanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.DELAI_PAIEMENT;
		this.defaultSize = 6;
		this.icon = { name: 'clock' };
	}

	getLibelle = () => 'Délai global de paiement';

	isEmpty = (data: Mouvement) =>
		!data?.dureeDelaiGlobalPaiement &&
		!data?.dateDepartDelaiGlobalPaiement &&
		!data?.dateFinDelaiGlobalPaiement;

	isComplete = (data: Mouvement) =>
		this.allPresent(
			data?.dureeDelaiGlobalPaiement,
			data?.dateDepartDelaiGlobalPaiement,
			data?.dateFinDelaiGlobalPaiement,
		);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<DelaiPaiementComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default DelaiPaiementPanel;
